import BaseWidget from "common/widgets/base/BaseWidget";
import classes from "app/css/widgets/Link.module.less";

/**
 * Link widget to support handling Enter key on <a> tags.  Some browsers, Chrome at least, will not let you
 * click a link that does not have an href on it, even if you set a tabIndex.
 * For inline links, we had been setting href="javascript:void()",
 * but that is not possible anymore due to our security policy changes.
 */
const Link = BaseWidget(kendo.ui.Widget).extend({

    options: {
        name: "Link"
    },

    events: [
        "click"
    ],

    init: function(element, options) {

        kendo.ui.Widget.fn.init.apply(this, arguments);

        var me = this;

        if (!me.element.attr("tabindex")) {
            me.element.attr("tabindex", 0);
        }

        me.element.on("keypress", function(e) {
            if (e.which == 13) {
                me.element.click();
            }
        });

        me.element.on("click", function(e) {
            if (me.trigger("click", {
                    event: e
                })) {
                e.preventDefault();
            }
        });

        me.wrapper = me.element;
        this.wrapper.addClass(classes.Link);
    },

    destroy: function() {
        this.element.off("keypress");
        this.element.off("click");
        kendo.ui.Widget.fn.destroy.call(this);
    },

    /**
     * Set focus to the link
     */
    focus: function() {
        this.getARIAElements().focus();
    }
});

kendo.ui.plugin(Link);
export default Link;
